<template>
    <VForm
        v-slot="{ form }"
        :on-submit-async="submit"
        @success="(value)=>this.$emit('success',value)">
        <ReferralPromotionCreateAndUpdateFormItems :form="form" />
    </VForm>
</template>
<script>
import { rootActions } from '@/store/types'
import VForm from '@/components/VForm.vue'
import ReferralPromotionCreateAndUpdateFormItems from '@/components/ReferralPromotionCreateAndUpdateFormItems.vue'

export default {
    components: {
        VForm,
        ReferralPromotionCreateAndUpdateFormItems,
    },
    methods: {
        async submit (values) {
            const res = await this.$store.dispatch(
                rootActions.ADD_REFERRAL_PROMOTION, { ...values },
            )
            return res
        },
    },
}
</script>
